import React from 'react';

const NotFound = () => {
    return (
        <div className='flex items-center justify-center'>
            <img className='w-full h-auto' src='https://i.ibb.co/rm5WX9F/notfound.jpg' alt="not found" />
        </div>
    );
};

export default NotFound;